import { fmlmCalculateDistance } from "../../../app/api/fmlmSearchLocation";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { IDistanceResponse } from "../../../Orchestrator/Types/Interface/IDistance";

export async function distanceCalculate(
  start: [number, number],
  end: [number, number][]
): Promise<number[]> {
  try {

    if (!end.length) {
      console.warn("No end points provided for distance calculation.");
      return [];
    }

    const coordinates = `${start[0]},${start[1]};${end?.map(point => `${point[0]},${point[1]}`).join(';')}`;
    const response: IApiResponse<IDistanceResponse> = await fmlmCalculateDistance(coordinates);

    let searchLocationDistanceList = response.answer?.distances?.[0]?.slice(1) || [];

    if (response.status === "ok" && searchLocationDistanceList.length > 0) {
      return searchLocationDistanceList.map(distance => +(distance / 1000).toFixed(2));
    }

    console.warn("Unexpected response structure:", response);
  } catch (error) {
    console.error("Error fetching distance from service:", error);
  }
  return [];
}
